module.exports = __webpack_public_path__ + "img/slot_machine.e6229548.gif";